import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { of } from 'rxjs';
import { HashMap, LocalizationService } from '@capital-access/common/localization';
import { IconSize } from '@capital-access/common/utils';
import { FireflyPopoverModule } from '@capital-access/firefly/components';
import { COMMON_COMPONENTS_LOCALIZATION_SCOPE } from '../common-components.const';
import {
  TargetingDataPointFields,
  TargetingDataPointLocalization,
  TargetingDataPointLocalizationKeys,
  TargetingDataPointTitle
} from './models/ca-targeting-data-enum';

@Component({
  selector: 'ca-targeting-data-points-popover',
  imports: [CommonModule, FireflyPopoverModule],
  templateUrl: './targeting-data.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TargetingDataPointsPopoverComponent {
  title = input.required<TargetingDataPointTitle>();
  hasInfoBottom = input<boolean>(false);
  hasInfoBottomSecondary = input<boolean>(false);
  isShowTitle = input<boolean>(true);
  iconSize = input<IconSize>(IconSize.Sm);

  readonly localizationService = toSignal(
    inject(LocalizationService, { optional: true })?.getLocalization(COMMON_COMPONENTS_LOCALIZATION_SCOPE) ??
      of({} as HashMap),
    { initialValue: {} as HashMap }
  );

  readonly localizedTitle = computed(() => this.getInfo(this.title(), 'title'));

  readonly mainInfo = computed(() => this.getInfo(this.title(), 'info'));

  readonly infoBottomPrimary = computed(() => (this.hasInfoBottom() ? this.getInfo(this.title(), 'primaryInfo') : ''));

  readonly infoBottomSecondary = computed(() =>
    this.hasInfoBottomSecondary() ? this.getInfo(this.title(), 'secondaryInfo') : ''
  );

  private getInfo(datapoint: TargetingDataPointTitle, infoType: keyof TargetingDataPointFields) {
    return (
      this.localizationService()[TargetingDataPointLocalizationKeys[datapoint]?.[infoType] || ''] ||
      TargetingDataPointLocalization[datapoint]?.[infoType]
    );
  }
}
